<template>
  <div class="charge_detail" v-if="orderInfo">
    <div class="header">
      <div class="header_name">{{orderInfo.parkName}}</div>
      <div class="header_time">{{orderInfo.reserveEndTimeStr}}</div>
      <div class="header_hint">本次订单按照该停车场标准收费</div>
    </div>
    <div class="list">
      <div class="li">
        <div class="list_title">
          <div>停车收费</div>
          <div>{{orderInfo.normalChargeStr}}</div>
        </div>
        <div class="explain">含时长{{orderInfo.normalTimeStr}}，每小时{{orderInfo.normalChargeStr}}元</div>
      </div>
      <div class="li">
        <div class="list_title">
          <div>超时收费</div>
          <div>{{orderInfo.timeoutChargeStr}}</div>
        </div>
        <div class="explain">含时长{{orderInfo.timeoutTimeStr}}，每小时{{orderInfo.timeoutStandard}}元</div>
        <div class="explain" v-if="orderInfo.timeoutBeginTime&&orderInfo.timeoutEndTime">{{orderInfo.timeoutBeginTime}}-{{orderInfo.timeoutEndTime}}</div>
      </div>
    </div>
    <div class="statistical">
      合计：¥{{orderInfo.parkRealMoney}}
    </div>
  </div>
</template>

<script>
  export default {
    name: "ChargeDetail",
    data: function () {
      return {
        orderId: '',
        orderInfo:null
      }
    },
    created: function () {
      this.orderId = this.$route.query.orderId;
      this.getChargeDetail();
    },
    methods:{
      getChargeDetail:function () {
        this.$indicator.open('正在查询');
        this.$ajax.get('/myorder/getTimeOutMoneyDetail/'+this.orderId)
          .then(res=>{
            this.$indicator.close();
            this.orderInfo = res.data.data;
            window.console.log(res);
          })
          .catch(error=>{
            window.console.log(error);
          })
      }

    }
  }
</script>

<style lang="scss" type="text/scss">
  @function tovw($px) {
    @return $px / 7.5px * 1vw;
  }
  .charge_detail{
    width: 100vw;
    height: 100vh;
    overflow: auto;
    padding: tovw(50px) tovw(94px);
    background-color: #fff;
    .header{
      text-align: center;
      margin: tovw(30px) 0 tovw(60px);
      &_name{
        font-size: tovw(36px);
      }
      &_time{
        color: #999999;
        margin: tovw(10px) 0;
      }
      &_hint{
        font-size: tovw(24px);
        color: #e48600;
      }
    }
    .list{
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      padding: tovw(15px) 0;
      .li{
        margin: tovw(30px) 0;
      }
      &_title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: tovw(10px);
      }
      .explain{
        font-size: tovw(24px);
        color: #999;
        margin-bottom: tovw(10px);
      }
    }
    .statistical{
      text-align: right;
      margin-top: tovw(30px);
    }
  }
</style>